import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { ReceiptService } from "../../../api/receipt.service";
import { Receipt } from "../../../models/receipt/receipt";
import { RECEIPT_STATUS } from "../../../models/receipt/types";

// Every status a receipt can no longer transition out of — once reached, further polling only
// wastes requests. Covers both the hailing/QR lifecycle and MOBILE_PAYMENT's own SUCCESS/FAILURE.
const TERMINAL_RECEIPT_STATUSES: string[] = [
  RECEIPT_STATUS.CANCELLED,
  RECEIPT_STATUS.COMPLETED,
  RECEIPT_STATUS.SUCCESS,
  RECEIPT_STATUS.SUCCESSFUL,
  RECEIPT_STATUS.TIMED_OUT,
  RECEIPT_STATUS.FAILED,
  RECEIPT_STATUS.EXPIRED,
  RECEIPT_STATUS.FAILURE,
];

export const useReceiptData = (setAlert?: (alert: any) => void) => {
  const { id: txId } = useParams<{ id: string }>();
  const receiptService = new ReceiptService();

  return useQuery<Receipt>(
    ["receipt", txId],
    async () => {
      if (!txId) throw new Error("Missing txId");
      try {
        const res = await receiptService.getReceipt(txId);
        if (!res.data) throw new Error("No receipt data returned");
        return res.data as Receipt;
      } catch (error: any) {
        if (setAlert) {
          setAlert({
            severity: "error",
            show: true,
            title: "Error",
            message:
              error?.response?.data?.description ||
              error?.description ||
              error?.message ||
              "Failed to fetch receipt.",
          });
        }
        throw error;
      }
    },
    {
      enabled: !!txId,
      refetchOnWindowFocus: false,
      retry: false,
      refetchInterval: (data) => (data?.status && TERMINAL_RECEIPT_STATUSES.includes(data.status) ? false : 5000),
    }
  );
};